function Logo() {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z"
        fill="#979797"
      />
      <g clipPath="url(#clip0_5441_103084)">
        <path
          d="M10.2524 9.01857L10.4694 7.49942H9.02264V6.52283C9.02264 6.08878 9.23966 5.69091 9.89072 5.69091H10.5418V4.38878C10.5418 4.38878 9.92689 4.28027 9.34817 4.28027C8.15455 4.28027 7.35881 5.00368 7.35881 6.34198V7.49942H6.02051V9.01857H7.35881V12.7079C7.612 12.7441 7.90136 12.7803 8.19072 12.7803C8.48008 12.7803 8.73327 12.7441 9.02264 12.7079V9.01857H10.2524Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5441_103084">
          <rect width="3.1875" height="8.5" fill="white" transform="translate(7.4375 4.25)" />
        </clipPath>
      </defs>
    </svg>
  );
}

function DashboardIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32.2" height="29.146" viewBox="0 0 32.2 29.146">
      <path
        id="Vector"
        d="M10.846,29.146H5.6a1.755,1.755,0,0,1-1.75-1.75V15.146H.871a.871.871,0,0,1-.577-1.523L14.924.446a1.763,1.763,0,0,1,2.345,0L31.9,13.624a.868.868,0,0,1-.577,1.523H28.346V27.4a1.755,1.755,0,0,1-1.75,1.75h-5.25A1.755,1.755,0,0,1,19.6,27.4v-8.75h-7V27.4a1.755,1.755,0,0,1-1.75,1.75Z"
        transform="translate(0)"
        fill="#a3aed0"
      />
    </svg>
  );
}

function UserManagementIcon() {
  return (
    <svg
      id="Multiple_users_silhouette"
      data-name="Multiple users silhouette"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Multiple_users_silhouette_Frame_Background_"
        data-name="Multiple users silhouette [Frame Background]"
        width="32"
        height="32"
        fill="none"
      />
      <g id="Group">
        <path
          id="Vector"
          d="M24,0a4.693,4.693,0,1,1-1.983,8.942,5.815,5.815,0,0,0-2.706-4.32A4.693,4.693,0,0,1,24,0ZM11.542,9.538a4.694,4.694,0,1,1,4.694,4.693A4.694,4.694,0,0,1,11.542,9.538ZM24.235,20.561v4.871H24.2l-.313.159a16.773,16.773,0,0,1-7.134,1.339,27.352,27.352,0,0,1-8.17-1.317l-.335-.105-.012-.076v-4.87a6.016,6.016,0,0,1,6.009-6.009h3.982a6.014,6.014,0,0,1,6.008,6.009ZM32,15.715v4.872h-.034l-.313.159a16.171,16.171,0,0,1-6.3,1.323v-1.5a7.14,7.14,0,0,0-5.1-6.833A5.784,5.784,0,0,0,22.04,9.706h3.952A6.016,6.016,0,0,1,32,15.715ZM3.308,4.694a4.693,4.693,0,1,1,9.386,0c0,.089-.008.176-.013.264a5.808,5.808,0,0,0-2.183,3.7A4.686,4.686,0,0,1,3.308,4.694ZM7.115,20.568v1.471A28.174,28.174,0,0,1,.348,20.767l-.335-.106L0,20.586V15.715A6.016,6.016,0,0,1,6.009,9.706H9.991c.149,0,.294.012.441.022a5.787,5.787,0,0,0,1.784,4.006,7.142,7.142,0,0,0-5.1,6.833Z"
          transform="translate(0 2.535)"
          fill="#a3aed0"
        />
      </g>
    </svg>
  );
}

function ReportManagementIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32">
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Report_Frame_Clip_Content_Mask_"
            data-name="Report [Frame Clip Content Mask]"
            width="32"
            height="32"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Report_Clip_Content_" data-name="Report (Clip Content)" clipPath="url(#clipPath)">
        <rect
          id="Report_Frame_Background_"
          data-name="Report [Frame Background]"
          width="32"
          height="32"
          fill="none"
        />
        <g id="Group">
          <g id="Group-2" data-name="Group">
            <path
              id="Vector"
              d="M8.8,8.8H0V0Z"
              transform="translate(21.882 0.611)"
              fill="#a3aed0"
            />
          </g>
        </g>
        <g id="Group-3" data-name="Group">
          <g id="Group-4" data-name="Group">
            <path
              id="Vector-2"
              data-name="Vector"
              d="M24.675,11.5V29.279a1.043,1.043,0,0,1-1.044,1.043H9.1a9.508,9.508,0,0,0,.692-1.043,9.4,9.4,0,0,0,.513-1.043,9.5,9.5,0,0,0,.728-3.663,9.451,9.451,0,0,0-2.787-6.727h0a9.443,9.443,0,0,0-6.155-2.769c-.19-.011-.381-.018-.573-.018q-.237,0-.471.012A9.5,9.5,0,0,0,0,15.18V1.044A1.044,1.044,0,0,1,1.044,0H13.177V10.455A1.044,1.044,0,0,0,14.22,11.5H24.675Z"
              transform="translate(6.619)"
              fill="#a3aed0"
            />
          </g>
        </g>
        <g id="Group-5" data-name="Group">
          <g id="Group-6" data-name="Group">
            <path
              id="Vector-3"
              data-name="Vector"
              d="M5.951,4.463A7.384,7.384,0,0,1,4.98,8.139c-.086.15-.177.3-.274.441L4.7,8.593c-.076.113-.153.224-.236.333L0,4.463,1.834,2.628,4.463,0A7.371,7.371,0,0,1,5.951,4.463Z"
              transform="translate(9.609 20.11)"
              fill="#a3aed0"
            />
          </g>
        </g>
        <g id="Group-7" data-name="Group">
          <g id="Group-8" data-name="Group">
            <path
              id="Vector-4"
              data-name="Vector"
              d="M6.689,8.165l5.2,5.2A7.428,7.428,0,1,1,7.427,0l.119,0A7.366,7.366,0,0,1,11.89,1.489L9.665,3.714,6.689,6.689a1.043,1.043,0,0,0,0,1.476Z"
              transform="translate(0.706 17.146)"
              fill="#a3aed0"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

function CompanyManagementIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
      <g id="Group" transform="translate(-37 -433)">
        <path
          id="Vector"
          d="M3.68,7.4a3.7,3.7,0,1,1,3.7-3.7,3.7,3.7,0,0,1-3.7,3.7Z"
          transform="translate(39.651 433)"
          fill="#a3aed0"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M11.665,8.432H1a1,1,0,0,1-1-1V6.3a6.331,6.331,0,0,1,12.661,0V7.436a1,1,0,0,1-1,1Z"
          transform="translate(37 440.43)"
          fill="#a3aed0"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M3.68,7.4a3.7,3.7,0,1,1,3.7-3.7,3.7,3.7,0,0,1-3.7,3.7Z"
          transform="translate(60.99 433)"
          fill="#a3aed0"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M12.661,6.331V7.468a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V6.331a6.331,6.331,0,0,1,12.661,0Z"
          transform="translate(58.339 440.398)"
          fill="#a3aed0"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M6.261,8.784A8.342,8.342,0,0,0,5.2,10.477,12.718,12.718,0,0,1,0,0H1.994c0,.071,0,.141,0,.213A10.723,10.723,0,0,0,6.261,8.784Z"
          transform="translate(41.268 450.854)"
          fill="#a3aed0"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,1.489a12.856,12.856,0,0,1,12.012,0A8.39,8.39,0,0,0,10.4,2.916a10.848,10.848,0,0,0-8.792,0A8.394,8.394,0,0,0,0,1.489Z"
          transform="translate(47.994 438.349)"
          fill="#a3aed0"
        />
        <path
          id="Vector-7"
          data-name="Vector"
          d="M6.258,0a12.718,12.718,0,0,1-5.2,10.477A8.344,8.344,0,0,0,0,8.784,10.729,10.729,0,0,0,4.266,0Z"
          transform="translate(60.471 450.854)"
          fill="#a3aed0"
        />
        <path
          id="Vector-8"
          data-name="Vector"
          d="M3.68,7.4a3.7,3.7,0,1,1,3.7-3.7,3.7,3.7,0,0,1-3.7,3.7Z"
          transform="translate(50.32 451.138)"
          fill="#a3aed0"
        />
        <path
          id="Vector-9"
          data-name="Vector"
          d="M12.661,6.331V7.469a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V6.331a6.331,6.331,0,0,1,12.661,0Z"
          transform="translate(47.669 458.535)"
          fill="#a3aed0"
        />
      </g>
    </svg>
  );
}

function ContactSupportIcon() {
  return (
    <svg
      id="Help_desk"
      data-name="Help desk"
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
    >
      <rect
        id="Help_desk_Frame_Background_"
        data-name="Help desk [Frame Background]"
        width="31"
        height="31"
        fill="none"
      />
      <g id="Group">
        <path
          id="Vector"
          d="M27.246,7.568V8.6a.908.908,0,0,1-.908.908H.908A.908.908,0,0,1,0,8.6V7.568A7.577,7.577,0,0,1,7.568,0H9.093a4.546,4.546,0,0,0,4.53,4.238A4.546,4.546,0,0,0,18.153,0h1.525a7.577,7.577,0,0,1,7.568,7.568Z"
          transform="translate(1.877 21.494)"
          fill="#a3aed0"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,1.816A1.816,1.816,0,0,1,1.816,0V3.633A1.816,1.816,0,0,1,0,1.816Z"
          transform="translate(5.813 9.99)"
          fill="#a3aed0"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M5.052,8.174H0v-.3a7.871,7.871,0,0,1,15.742,0v.3h-1.5L11.466,5.951a.908.908,0,0,0-1.21.067,7.36,7.36,0,0,1-5.2,2.156Z"
          transform="translate(7.629)"
          fill="#a3aed0"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M2.725.486A7.834,7.834,0,0,0,5.449,0V.486A2.725,2.725,0,0,1,0,.486V0A7.833,7.833,0,0,0,2.725.486Z"
          transform="translate(12.775 20.705)"
          fill="#a3aed0"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M6.66,9.7h3.718A6.054,6.054,0,0,1,0,5.466V2.135H3.235A9.109,9.109,0,0,0,9.121,0l2.988,2.39V5.466a6.033,6.033,0,0,1-.5,2.422H6.66a.908.908,0,0,0,0,1.816Z"
          transform="translate(9.445 7.855)"
          fill="#a3aed0"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M3.548,0h.908A1.816,1.816,0,0,1,6.272,1.816V4.238a3.334,3.334,0,0,1-3.33,3.33H0A6.065,6.065,0,0,0,1.227,5.752H2.942A1.515,1.515,0,0,0,4.456,4.238V3.633H3.548Z"
          transform="translate(19.823 9.99)"
          fill="#a3aed0"
        />
      </g>
    </svg>
  );
}

function SettingIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31">
      <g id="Group" transform="translate(-40 -613)">
        <path
          id="Vector"
          d="M10.131,21.413H9.14a.908.908,0,0,1-.908-.908V18.863a8.484,8.484,0,0,1-1.543-.638l-1.16,1.16a.908.908,0,0,1-1.284,0L2.028,17.169a.908.908,0,0,1,0-1.284L3.183,14.73a8.485,8.485,0,0,1-.645-1.549H.908A.908.908,0,0,1,0,12.273V9.14a.908.908,0,0,1,.908-.908H2.527A8.481,8.481,0,0,1,3.17,6.67L2.028,5.528a.908.908,0,0,1,0-1.284L4.244,2.028a.908.908,0,0,1,1.284,0L6.665,3.165a8.49,8.49,0,0,1,1.567-.651V.908A.908.908,0,0,1,9.14,0h3.133a.908.908,0,0,1,.908.908V2.514a8.484,8.484,0,0,1,1.567.651l1.137-1.137a.908.908,0,0,1,1.284,0l2.216,2.216a.908.908,0,0,1,0,1.284L18.242,6.67a8.485,8.485,0,0,1,.644,1.561H20.5a.908.908,0,0,1,.908.908v.992H20.13a2.68,2.68,0,0,0-2.563,1.909A2.682,2.682,0,0,0,15,12.056,4.492,4.492,0,1,0,12.056,15a2.682,2.682,0,0,0-.016,2.571,2.68,2.68,0,0,0-1.909,2.563Z"
          transform="translate(40 613)"
          fill="#a3aed0"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M18.193,11.728h-1.4a7.548,7.548,0,0,1-.574,1.378l.992.992a.859.859,0,0,1,0,1.214l-1.9,1.9a.859.859,0,0,1-1.214,0l-1-1a7.548,7.548,0,0,1-1.373.568v1.41a.859.859,0,0,1-.859.859H8.183a.859.859,0,0,1-.859-.859v-1.41a7.548,7.548,0,0,1-1.373-.568l-1,1a.859.859,0,0,1-1.214,0l-1.9-1.9a.859.859,0,0,1,0-1.214l.992-.992a7.55,7.55,0,0,1-.574-1.378H.859A.859.859,0,0,1,0,10.869V8.183a.859.859,0,0,1,.859-.859h1.39a7.545,7.545,0,0,1,.573-1.389L1.84,4.954a.859.859,0,0,1,0-1.214l1.9-1.9a.859.859,0,0,1,1.214,0l.976.976a7.554,7.554,0,0,1,1.394-.579V.859A.859.859,0,0,1,8.183,0h2.687a.859.859,0,0,1,.859.859V2.237a7.544,7.544,0,0,1,1.394.579L14.1,1.84a.859.859,0,0,1,1.214,0l1.9,1.9a.859.859,0,0,1,0,1.214l-.981.981A7.553,7.553,0,0,1,16.8,7.324h1.39a.859.859,0,0,1,.859.859v2.687a.859.859,0,0,1-.859.859ZM13.358,9.777a3.841,3.841,0,1,0-3.581,3.581,3.844,3.844,0,0,0,3.581-3.581Z"
          transform="translate(51.948 624.948)"
          fill="#a3aed0"
        />
      </g>
    </svg>
  );
}

function NotificationIcon() {
  return (
    <svg
      id="notifications_none"
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="30"
      viewBox="0 0 30 30"
    >
      <path id="Vector" d="M0,0H36V30H0Z" fill="none" />
      <path
        id="Vector-2"
        data-name="Vector"
        d="M21.25,20.625H1.495c-1.335,0-2-1.35-1.05-2.138L2.38,16.875v-6.25a7.864,7.864,0,0,1,6.75-7.9v-.85A2.085,2.085,0,0,1,11.38,0a2.085,2.085,0,0,1,2.25,1.875v.85a7.887,7.887,0,0,1,6.75,7.9v6.25l1.935,1.612C23.26,19.275,22.6,20.625,21.25,20.625Zm-3.87-10c0-3.1-2.265-5.625-6-5.625s-6,2.525-6,5.625v7.5h12Zm-9,11.25h6a2.793,2.793,0,0,1-3,2.5A2.783,2.783,0,0,1,8.38,21.875Z"
        transform="translate(6.62 3.125)"
        fill="#a3aed0"
      />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27">
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Exit_Frame_Clip_Content_Mask_"
            data-name="Exit [Frame Clip Content Mask]"
            width="27"
            height="27"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_419" data-name="Group 419" transform="translate(-280 -1145)">
        <g
          id="Exit_Clip_Content_"
          data-name="Exit (Clip Content)"
          transform="translate(280 1145)"
          clipPath="url(#clipPath)"
        >
          <rect
            id="Exit_Frame_Background_"
            data-name="Exit [Frame Background]"
            width="27"
            height="27"
            fill="none"
          />
          <g id="Group">
            <g id="Group-2" data-name="Group">
              <path
                id="Vector"
                d="M11.074,6.518V24.623A2.376,2.376,0,0,1,7.388,26.6L1.06,22.586A2.357,2.357,0,0,1,0,20.609V2.167A2.385,2.385,0,0,1,1.408,0L9.635,4.319a2.432,2.432,0,0,1,1.44,2.2Zm-3.164,5.4a.791.791,0,1,0-1.582,0v3.164a.791.791,0,1,0,1.582,0Z"
                transform="translate(0)"
                fill="#fff"
              />
            </g>
          </g>
          <g id="Group-3" data-name="Group">
            <g id="Group-4" data-name="Group">
              <path
                id="Vector-2"
                data-name="Vector"
                d="M14.031,5.376,8.469,9.259A.791.791,0,0,1,7.119,8.7V6.328H.791A.791.791,0,0,1,0,5.537V3.955a.791.791,0,0,1,.791-.791H7.119V.793A.791.791,0,0,1,8.47.233l5.561,3.883a.791.791,0,0,1,0,1.26Z"
                transform="translate(12.656 8.754)"
                fill="#fff"
              />
            </g>
          </g>
          <g id="Group-5" data-name="Group">
            <g id="Group-6" data-name="Group">
              <path
                id="Vector-3"
                data-name="Vector"
                d="M4.746,0V4.8A2.376,2.376,0,0,1,2.373,7.172H0V0H4.746Z"
                transform="translate(12.656 16.664)"
                fill="#fff"
              />
            </g>
          </g>
          <g id="Group-7" data-name="Group">
            <g id="Group-8" data-name="Group">
              <path
                id="Vector-4"
                data-name="Vector"
                d="M12.591,2.373v7.963H7.845V6.518a4,4,0,0,0-2.287-3.6L5.531,2.9h0l0,0L0,0H10.218a2.376,2.376,0,0,1,2.373,2.373Z"
                transform="translate(4.811)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

function AddIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.035"
      height="10.035"
      viewBox="0 0 10.035 10.035"
    >
      <path
        id="Icon_ionic-ios-add"
        data-name="Icon ionic-ios-add"
        d="M17.438,12.92H14.045V9.527a.563.563,0,0,0-1.125,0V12.92H9.527a.563.563,0,0,0,0,1.125H12.92v3.393a.563.563,0,0,0,1.125,0V14.045h3.393a.563.563,0,0,0,0-1.125Z"
        transform="translate(-8.465 -8.465)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      />
    </svg>
  );
}

function DeleteIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
      <g id="Delete" transform="translate(-1647 -297)">
        <rect
          id="Rectangle_2"
          data-name="Rectangle 2"
          width="36"
          height="36"
          rx="5"
          transform="translate(1647 297)"
          fill="#f46569"
        />
        <path
          id="Icon_material-delete-forever"
          data-name="Icon material-delete-forever"
          d="M8.571,21.643a2.149,2.149,0,0,0,2.143,2.143h8.571a2.149,2.149,0,0,0,2.143-2.143V8.786H8.571Zm2.636-7.629L12.718,12.5,15,14.775,17.271,12.5l1.511,1.511-2.271,2.271,2.271,2.271-1.511,1.511L15,17.8l-2.271,2.271-1.511-1.511,2.271-2.271ZM18.75,5.571,17.679,4.5H12.321L11.25,5.571H7.5V7.714h15V5.571Z"
          transform="translate(1650.5 300.5)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

function EditIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
      <g id="Group_59355" data-name="Group 59355" transform="translate(-1524 -404)">
        <g id="Delete" transform="translate(-123 107)">
          <rect
            id="Rectangle_2"
            data-name="Rectangle 2"
            width="36"
            height="36"
            rx="5"
            transform="translate(1647 297)"
            fill="#21f13d"
          />
        </g>
        <path
          id="Icon_awesome-edit"
          data-name="Icon awesome-edit"
          d="M13.979,2.892l3.132,3.132a.339.339,0,0,1,0,.479L9.528,14.087l-3.222.358a.675.675,0,0,1-.747-.747l.358-3.222L13.5,2.892A.339.339,0,0,1,13.979,2.892ZM19.6,2.1,17.91.4a1.358,1.358,0,0,0-1.917,0L14.764,1.632a.339.339,0,0,0,0,.479L17.9,5.243a.34.34,0,0,0,.479,0L19.6,4.014a1.358,1.358,0,0,0,0-1.917Zm-6.271,9.927v3.535H2.222V4.448H10.2a.427.427,0,0,0,.3-.122l1.389-1.389a.417.417,0,0,0-.3-.712H1.667A1.667,1.667,0,0,0,0,3.892V16.115a1.667,1.667,0,0,0,1.667,1.667H13.889a1.667,1.667,0,0,0,1.667-1.667V10.636a.417.417,0,0,0-.712-.3l-1.389,1.389A.427.427,0,0,0,13.333,12.024Z"
          transform="translate(1533 412.993)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

function BlockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
      <g id="blovk" transform="translate(-1647 -297)">
        <rect
          id="Rectangle_3"
          data-name="Rectangle 3"
          width="36"
          height="36"
          rx="5"
          transform="translate(1647 297)"
          fill="#bee4fa"
        />
        <path
          id="Icon_metro-blocked"
          data-name="Icon metro-blocked"
          d="M19.642,4.857A10,10,0,0,0,5.5,19,10,10,0,0,0,19.642,4.857Zm.429,7.071a7.459,7.459,0,0,1-1.389,4.343L8.227,5.817a7.5,7.5,0,0,1,11.843,6.111Zm-15,0A7.459,7.459,0,0,1,6.46,7.585L16.914,18.039A7.5,7.5,0,0,1,5.071,11.928Z"
          transform="translate(1652.429 303.072)"
          fill="#2b3674"
        />
      </g>
    </svg>
  );
}

function CameraIcon() {
  return (
    <svg
      id="Group_561"
      data-name="Group 561"
      xmlns="http://www.w3.org/2000/svg"
      width="55.5"
      height="55.5"
      viewBox="0 0 95.5 95.5"
    >
      <g id="Path_78" data-name="Path 78" transform="translate(0 0)" fill="#f46569">
        <path
          d="M 27.74999809265137 54.5 C 24.13832855224609 54.5 20.63522720336914 53.79286956787109 17.33799743652344 52.39825820922852 C 14.15274810791016 51.05100631713867 11.29188823699951 49.12209701538086 8.834888458251953 46.66510772705078 C 6.377898216247559 44.20810699462891 4.44898796081543 41.34724807739258 3.101737976074219 38.1619987487793 C 1.707128047943115 34.86476898193359 0.9999980926513672 31.36166763305664 0.9999980926513672 27.74999809265137 C 0.9999980926513672 24.13832855224609 1.707128047943115 20.63522720336914 3.101737976074219 17.33799743652344 C 4.44898796081543 14.15274810791016 6.377898216247559 11.29188823699951 8.834888458251953 8.834888458251953 C 11.29188823699951 6.377898216247559 14.15274810791016 4.44898796081543 17.33799743652344 3.101737976074219 C 20.63522720336914 1.707128047943115 24.13832855224609 0.9999980926513672 27.74999809265137 0.9999980926513672 C 31.36166763305664 0.9999980926513672 34.86476898193359 1.707128047943115 38.1619987487793 3.101737976074219 C 41.34724807739258 4.44898796081543 44.20810699462891 6.377898216247559 46.66510772705078 8.834888458251953 C 49.12209701538086 11.29188823699951 51.05100631713867 14.15274810791016 52.39825820922852 17.33799743652344 C 53.79286956787109 20.63522720336914 54.5 24.13832855224609 54.5 27.74999809265137 C 54.5 31.36166763305664 53.79286956787109 34.86476898193359 52.39825820922852 38.1619987487793 C 51.05100631713867 41.34724807739258 49.12209701538086 44.20810699462891 46.66510772705078 46.66510772705078 C 44.20810699462891 49.12209701538086 41.34724807739258 51.05100631713867 38.1619987487793 52.39825820922852 C 34.86476898193359 53.79286956787109 31.36166763305664 54.5 27.74999809265137 54.5 Z"
          stroke="none"
        />
        <path
          d="M 27.74999809265137 1.999996185302734 C 24.27288818359375 1.999996185302734 20.90084838867188 2.680549621582031 17.72754669189453 4.022739410400391 C 14.6614990234375 5.319568634033203 11.90747833251953 7.176517486572266 9.541999816894531 9.541999816894531 C 7.176517486572266 11.90747833251953 5.319568634033203 14.6614990234375 4.022739410400391 17.72754669189453 C 2.680549621582031 20.90084838867188 1.999996185302734 24.27288818359375 1.999996185302734 27.74999809265137 C 1.999996185302734 31.22710800170898 2.680549621582031 34.59914779663086 4.022739410400391 37.77244567871094 C 5.319568634033203 40.83849716186523 7.176517486572266 43.5925178527832 9.541999816894531 45.95800018310547 C 11.90747833251953 48.32347869873047 14.6614990234375 50.18042755126953 17.72754669189453 51.47725677490234 C 20.90084838867188 52.8194465637207 24.27288818359375 53.5 27.74999809265137 53.5 C 31.22710800170898 53.5 34.59914779663086 52.8194465637207 37.77244567871094 51.47725677490234 C 40.83849716186523 50.18042755126953 43.5925178527832 48.32347869873047 45.95800018310547 45.95800018310547 C 48.32347869873047 43.5925178527832 50.18042755126953 40.83849716186523 51.47725677490234 37.77244567871094 C 52.8194465637207 34.59914779663086 53.5 31.22710800170898 53.5 27.74999809265137 C 53.5 24.27288818359375 52.8194465637207 20.90084838867188 51.47725677490234 17.72754669189453 C 50.18042755126953 14.6614990234375 48.32347869873047 11.90747833251953 45.95800018310547 9.541999816894531 C 43.5925178527832 7.176517486572266 40.83849716186523 5.319568634033203 37.77244567871094 4.022739410400391 C 34.59914779663086 2.680549621582031 31.22710800170898 1.999996185302734 27.74999809265137 1.999996185302734 M 27.74999809265137 -3.814697265625e-06 C 43.07589721679688 -3.814697265625e-06 55.5 12.42409896850586 55.5 27.74999809265137 C 55.5 43.07589721679688 43.07589721679688 55.5 27.74999809265137 55.5 C 12.42409896850586 55.5 -3.814697265625e-06 43.07589721679688 -3.814697265625e-06 27.74999809265137 C -3.814697265625e-06 12.42409896850586 12.42409896850586 -3.814697265625e-06 27.74999809265137 -3.814697265625e-06 Z"
          stroke="none"
          fill="#fff"
        />
      </g>
      <g id="Camera" transform="translate(12.95 16.65)">
        <path
          id="Path_27574"
          data-name="Path 27574"
          d="M22.822,19.725a4.432,4.432,0,1,1-4.432-4.432A4.432,4.432,0,0,1,22.822,19.725Z"
          transform="translate(-3.589 -7.161)"
          fill="#fff"
        />
        <path
          id="Path_27575"
          data-name="Path 27575"
          d="M31.749,11.575h-4.2a1.251,1.251,0,0,1-.925-.416c-2.189-2.451-3.014-3.284-3.908-3.284H16.124c-.9,0-1.788.832-3.985,3.291a1.227,1.227,0,0,1-.917.409h-.316v-.617a.618.618,0,0,0-.617-.617h-2a.618.618,0,0,0-.617.617v.617H7.09A2.5,2.5,0,0,0,4.5,13.941V27.508a2.669,2.669,0,0,0,2.582,2.567H31.749A2.471,2.471,0,0,0,34.1,27.508V13.941A2.3,2.3,0,0,0,31.749,11.575ZM19.608,27.022a6.59,6.59,0,1,1,6.275-6.275A6.6,6.6,0,0,1,19.608,27.022ZM26.7,16.046a1,1,0,1,1,1-1A1,1,0,0,1,26.7,16.046Z"
          transform="translate(-4.5 -7.875)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

function AddCheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="113.666"
      height="113.666"
      viewBox="0 0 113.666 113.666"
    >
      <path
        id="Icon_awesome-check-circle"
        data-name="Icon awesome-check-circle"
        d="M114.229,57.4A56.833,56.833,0,1,1,57.4.563,56.833,56.833,0,0,1,114.229,57.4ZM50.822,87.488,92.988,45.322a3.667,3.667,0,0,0,0-5.185L87.8,34.951a3.667,3.667,0,0,0-5.186,0L48.229,69.339,32.174,53.284a3.667,3.667,0,0,0-5.186,0L21.8,58.47a3.667,3.667,0,0,0,0,5.185L45.636,87.488a3.667,3.667,0,0,0,5.186,0Z"
        transform="translate(-0.563 -0.563)"
        fill="#2b3674"
      />
    </svg>
  );
}

function InfoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.75" height="21.75" viewBox="0 0 21.75 21.75">
      <g
        id="Icon_ionic-ios-information-circle-outline"
        data-name="Icon ionic-ios-information-circle-outline"
        transform="translate(0.25 0.25)"
      >
        <path
          id="Path_27576"
          data-name="Path 27576"
          d="M16.552,11.725A1.053,1.053,0,1,1,17.6,12.747,1.023,1.023,0,0,1,16.552,11.725Zm.072,1.824h1.951V20.91H16.623Z"
          transform="translate(-6.979 -5.381)"
          fill="#ff0e0e"
          stroke="#ff0e0e"
          strokeWidth="0.5"
        />
        <path
          id="Path_27577"
          data-name="Path 27577"
          d="M14,4.805A9.191,9.191,0,1,1,7.5,7.5,9.134,9.134,0,0,1,14,4.805m0-1.43A10.625,10.625,0,1,0,24.625,14,10.624,10.624,0,0,0,14,3.375Z"
          transform="translate(-3.375 -3.375)"
          fill="#ff0e0e"
          stroke="#ff0e0e"
          strokeWidth="0.5"
        />
      </g>
    </svg>
  );
}

function MessageIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
      <g id="Delete" transform="translate(-1647 -297)">
        <rect
          id="Rectangle_2"
          data-name="Rectangle 2"
          width="36"
          height="36"
          rx="5"
          transform="translate(1647 297)"
          fill="#21f13d"
        />
        <path
          id="Icon_material-email"
          data-name="Icon material-email"
          d="M19.875,6h-15A1.872,1.872,0,0,0,3.009,7.875L3,19.125A1.88,1.88,0,0,0,4.875,21h15a1.88,1.88,0,0,0,1.875-1.875V7.875A1.88,1.88,0,0,0,19.875,6Zm0,3.75-7.5,4.687L4.875,9.75V7.875l7.5,4.687,7.5-4.687Z"
          transform="translate(1652.625 301.5)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

function BackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.743"
      height="23.34"
      viewBox="0 0 24.743 23.34"
    >
      <path
        id="Icon_ionic-md-arrow-round-back"
        data-name="Icon ionic-md-arrow-round-back"
        d="M28.223,15.75H13.177l5.836-5.583a2.326,2.326,0,0,0,0-3.178,2.079,2.079,0,0,0-3.038,0L6.258,16.411a2.142,2.142,0,0,0-.633,1.575v.028a2.142,2.142,0,0,0,.633,1.575l9.71,9.422a2.079,2.079,0,0,0,3.037,0,2.326,2.326,0,0,0,0-3.178L13.17,20.25H28.216A2.2,2.2,0,0,0,30.368,18,2.178,2.178,0,0,0,28.223,15.75Z"
        transform="translate(-5.625 -6.33)"
        fill="#515151"
      />
    </svg>
  );
}

function EyeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
      <g id="Delete" transform="translate(-1647 -297)">
        <rect
          id="Rectangle_2"
          data-name="Rectangle 2"
          width="36"
          height="36"
          rx="5"
          transform="translate(1647 297)"
          fill="#3e6eb9"
        />
        <path
          id="Icon_awesome-eye"
          data-name="Icon awesome-eye"
          d="M23.209,11.692A13,13,0,0,0,11.675,4.5,13,13,0,0,0,.141,11.692a1.311,1.311,0,0,0,0,1.183,13,13,0,0,0,11.534,7.192,13,13,0,0,0,11.534-7.192A1.311,1.311,0,0,0,23.209,11.692ZM11.675,18.121a5.838,5.838,0,1,1,5.838-5.838A5.838,5.838,0,0,1,11.675,18.121Zm0-9.729a3.864,3.864,0,0,0-1.026.154,1.94,1.94,0,0,1-2.712,2.712,3.883,3.883,0,1,0,3.738-2.866Z"
          transform="translate(1653 302.5)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
      <g id="Group_59424" data-name="Group 59424" transform="translate(-1674 -819)">
        <g id="blovk" transform="translate(27 522)">
          <rect
            id="Rectangle_3"
            data-name="Rectangle 3"
            width="36"
            height="36"
            rx="5"
            transform="translate(1647 297)"
            fill="#1ce45f"
          />
        </g>
        <path
          id="Icon_awesome-download"
          data-name="Icon awesome-download"
          d="M9,0h3.333a1,1,0,0,1,1,1V8h3.654a.832.832,0,0,1,.587,1.421l-6.337,6.342a.807.807,0,0,1-1.137,0L3.754,9.421A.832.832,0,0,1,4.342,8H8V1A1,1,0,0,1,9,0ZM21.333,15.667v4.667a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V15.667a1,1,0,0,1,1-1H7.112l2.042,2.042a2.135,2.135,0,0,0,3.025,0l2.042-2.042h6.112A1,1,0,0,1,21.333,15.667Zm-5.167,3.667a.833.833,0,1,0-.833.833A.836.836,0,0,0,16.167,19.333Zm2.667,0a.833.833,0,1,0-.833.833A.836.836,0,0,0,18.833,19.333Z"
          transform="translate(1681 826)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

function ShareIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
      <g id="Group_59348" data-name="Group 59348" transform="translate(-536 -736)">
        <g id="blovk" transform="translate(-1111 439)">
          <rect
            id="Rectangle_3"
            data-name="Rectangle 3"
            width="36"
            height="36"
            rx="5"
            transform="translate(1647 297)"
            fill="#bee4fa"
          />
        </g>
        <path
          id="Icon_awesome-reply-all"
          data-name="Icon awesome-reply-all"
          d="M4.95,7.982l6.391-5.519a.872.872,0,0,1,1.441.66V6.128c4.691.372,8.134,1.9,8.134,6.665a7.424,7.424,0,0,1-3.026,5.6.647.647,0,0,1-1.02-.677c1.4-4.472-.142-6.155-4.089-6.61V14.16a.872.872,0,0,1-1.441.66L4.95,9.3A.872.872,0,0,1,4.95,7.982ZM.3,9.3,6.693,14.82a.872.872,0,0,0,1.441-.66v-.574L4.19,10.18a2.034,2.034,0,0,1,0-3.078L8.134,3.7V3.122a.872.872,0,0,0-1.441-.66L.3,7.982A.872.872,0,0,0,.3,9.3Z"
          transform="translate(544 743.75)"
          fill="#2b3674"
        />
      </g>
    </svg>
  );
}

function SendIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62">
      <g id="Group_59360" data-name="Group 59360" transform="translate(-1813 -3983)">
        <circle
          id="Ellipse_411"
          data-name="Ellipse 411"
          cx="31"
          cy="31"
          r="31"
          transform="translate(1813 3983)"
          fill="#f46569"
        />
        <g id="Group_7046" data-name="Group 7046" transform="translate(1835.52 4004.56)">
          <path
            id="Vector"
            d="M16.851,0,0,2.019"
            transform="translate(4.874 7.399)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M21.219,7.4,1.075,19.752,4.368,9.417,0,0Z"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
}

function TimesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.039"
      height="12.038"
      viewBox="0 0 12.039 12.038"
    >
      <g id="cancel_1_" data-name="cancel (1)" transform="translate(0.5 0.5)">
        <g id="Group_5613" data-name="Group 5613">
          <path
            id="Path_7817"
            data-name="Path 7817"
            d="M6.735,5.535l4.127-4.127a.6.6,0,0,0,0-.854L10.5.192a.605.605,0,0,0-.854,0L5.52,4.319,1.392.192a.6.6,0,0,0-.854,0L.177.554a.6.6,0,0,0,0,.854L4.3,5.535.177,9.662a.605.605,0,0,0,0,.854l.362.362a.6.6,0,0,0,.854,0L5.52,6.751l4.127,4.127a.6.6,0,0,0,.427.176h0a.6.6,0,0,0,.427-.176l.362-.362a.605.605,0,0,0,0-.854Z"
            transform="translate(0 -0.016)"
            fill="#8392a5"
            stroke="#8392a5"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  );
}

function AuthSvgTop() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="160" viewBox="0 0 44 160">
      <g id="Illustration" transform="translate(-552 -64)">
        <rect
          id="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(552 64)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-2"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(565 64)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-3"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(578 64)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-4"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(591 64)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-5"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(565 204)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-6"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(578 204)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-7"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(591 204)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-8"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(565 176)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-9"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(578 176)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-10"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(565 148)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-11"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(591 148)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-12"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(578 120)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-13"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(591 120)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-14"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(565 92)"
          fill="rgba(255,255,255,0.53)"
        />
        <rect
          id="Rectangle-15"
          data-name="Rectangle"
          width="5"
          height="20"
          rx="1"
          transform="translate(578 92)"
          fill="rgba(255,255,255,0.53)"
        />
      </g>
    </svg>
  );
}

function AuthSvgBottom() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104">
      <g id="Illustration" transform="translate(-16 -904)">
        <circle
          id="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(16 904)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-2"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(40 904)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-3"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(64 904)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-4"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(88 904)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-5"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(112 904)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-6"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(16 928)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-7"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(40 928)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-8"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(64 928)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-9"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(88 928)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-10"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(112 928)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-11"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(16 952)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-12"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(40 952)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-13"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(64 952)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-14"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(88 952)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-15"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(112 952)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-16"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(16 976)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-17"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(40 976)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-18"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(64 976)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-19"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(88 976)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-20"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(112 976)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-21"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(16 1000)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-22"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(40 1000)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-23"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(64 1000)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-24"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(88 1000)"
          fill="rgba(255,255,255,0.51)"
        />
        <circle
          id="Ellipse-25"
          data-name="Ellipse"
          cx="4"
          cy="4"
          r="4"
          transform="translate(112 1000)"
          fill="rgba(255,255,255,0.51)"
        />
      </g>
    </svg>
  );
}

const TimesIconEmoji = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <g id="Group_59451" data-name="Group 59451" transform="translate(-1335 -183)">
        <circle
          id="Ellipse_408"
          data-name="Ellipse 408"
          cx="9"
          cy="9"
          r="9"
          transform="translate(1335 183)"
          fill="#e6e4eb"
        />
        <text
          id="X"
          transform="translate(1342 195)"
          fill="#8392a5"
          fontSize="8"
          fontFamily="Poppins-Regular, Poppins"
        >
          <tspan x="0" y="0">
            X
          </tspan>
        </text>
      </g>
    </svg>
  );
};

const SessionIntelligenceIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g transform="translate(0)">
        <path
          d="M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8l-2,4v2H22V28l-2-4h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM28,22H4V8H28ZM12,14h2v4H12Zm4-4h2v8H16Zm4-2h2v10H20Z"
          fill="#a3aed0"
        />
      </g>
    </svg>
  );
};

const ChatsIconEmoji = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 512 512">
      <g>
        <path
          d="M210.996 154.998C95.203 154.998.001 234.625.001 332.504c0 39.125 15.176 78.888 43.007 109.707L3.707 487.122a14.971 14.971 0 0 0-2.358 16.069 14.987 14.987 0 0 0 13.652 8.804h210.995c85.495 0 195.995-73.62 195.995-179.491 0-97.879-95.202-177.506-210.995-177.506zm-90.998 205c-16.538 0-29.999-13.462-29.999-29.999 0-16.538 13.462-29.999 29.999-29.999s29.999 13.462 29.999 29.999c.001 16.537-13.461 29.999-29.999 29.999zm90.998 0c-16.538 0-29.999-13.462-29.999-29.999 0-16.538 13.462-29.999 29.999-29.999s29.999 13.462 29.999 29.999-13.461 29.999-29.999 29.999zm90.998 0c-16.538 0-29.999-13.462-29.999-29.999 0-16.538 13.462-29.999 29.999-29.999s29.999 13.462 29.999 29.999-13.461 29.999-29.999 29.999z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
          className=""
        ></path>
        <path
          d="m508.371 305.228-35.316-41.205c25.209-28.446 38.935-63.134 38.935-99.021C511.989 74.023 424.511.006 316.994.006c-97.225 0-179.826 60.589-194.411 139.45 27.128-9.218 57.551-14.458 88.414-14.458 131.353 0 239.271 91.745 240.848 205h45.145c12.813.001 19.694-15.087 11.381-24.77z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
          className=""
        ></path>
      </g>
    </svg>
  );
};

const ChatAgentIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
      {/* Chat bubble */}
      <path d="M256 64c-106 0-192 68-192 152 0 33 13 66 37 93l-32 38c-6 7-1 17 8 17h179c106 0 192-68 192-152S362 64 256 64z" />

      {/* Agent head */}
      <circle cx="256" cy="190" r="45" fill="white" />

      {/* Shoulders */}
      <path d="M180 260c0-35 152-35 152 0v25H180z" fill="white" />

      {/* Headset band */}
      <path d="M210 190a46 46 0 0 1 92 0" fill="none" stroke="white" strokeWidth="10" />

      {/* Mic */}
      <path
        d="M300 230c0 15-15 20-28 20"
        fill="none"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
      />
    </svg>
  );
};
export {
  TimesIconEmoji,
  Logo,
  DashboardIcon,
  SessionIntelligenceIcon,
  ChatAgentIcon,
  UserManagementIcon,
  ReportManagementIcon,
  CompanyManagementIcon,
  ContactSupportIcon,
  SettingIcon,
  NotificationIcon,
  LogoutIcon,
  AddIcon,
  DeleteIcon,
  EditIcon,
  BlockIcon,
  CameraIcon,
  AddCheckIcon,
  InfoIcon,
  MessageIcon,
  BackIcon,
  EyeIcon,
  DownloadIcon,
  ShareIcon,
  SendIcon,
  TimesIcon,
  AuthSvgTop,
  AuthSvgBottom,
  ChatsIconEmoji,
};
